import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { COMPANIES_ENDPOINTS } from '../../api/endpoints/companies.endpoints';

@Injectable({
  providedIn: 'root',
})
export class CompanyClientService {
  private api = inject(ApiService);

  getOwners(params): Observable<any> {
    return this.api.get<any>(COMPANIES_ENDPOINTS.V1.COMPANY_ADMINS, {
      params: params,
    });
  }

  createOwner(data): Observable<any> {
    return this.api.post<any>(COMPANIES_ENDPOINTS.V1.COMPANY_ADMINS, data);
  }

  getMembers(): Observable<any> {
    return this.api.get<any>(COMPANIES_ENDPOINTS.V1.COMPANY_MEMBERS);
  }

  createMember(data): Observable<any> {
    return this.api.post<any>(COMPANIES_ENDPOINTS.V1.COMPANY_MEMBERS, data);
  }
}
